import React from 'react';

import { ICONS } from 'Components/utils/icon/icons';

import { Icon } from 'Components/frameworks/icon/Icon';

export const AdditionalTransportLayerIcons = () => (
  <div
    data-testid="AdditionalTransportLayerIcons"
    className="pointer-events-none absolute inset-0 -z-1 bg-pearl text-lightGrey"
  >
    <div className="fixed bottom-0 left-0 -mb-100 -translate-x-1/2 transform sm:mb-0">
      <Icon isNotSquare name={ICONS.PLANE_AND_CIRCLE} rotation={180} width="25rem" />
    </div>
    <div className="fixed right-0 top-0 -mt-100 translate-x-1/2 transform sm:mt-0">
      <Icon isNotSquare name={ICONS.PLANE_AND_CIRCLE} width="25rem" />
    </div>
  </div>
);
